import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getCatalogOffers } from "../servics/commercial/commercial-catalog-service";

/**
 * Offres du catalogue commercial ciblant un profil, au prix du pays d'activité.
 * Pour un utilisateur connecté, le backend applique le pays de son compte (JWT).
 */
const useCommercialCatalog = (profile) => {
    const country = useSelector((state) => state.country?.activityCountry?.value);
    const [state, setState] = useState({ loading: true, error: null, catalog: null });

    useEffect(() => {
        let cancelled = false;
        setState({ loading: true, error: null, catalog: null });
        getCatalogOffers({ profile, country })
            .then((catalog) => {
                if (!cancelled) setState({ loading: false, error: null, catalog });
            })
            .catch((error) => {
                if (!cancelled) setState({ loading: false, error, catalog: null });
            });
        return () => {
            cancelled = true;
        };
    }, [profile, country]);

    return state;
};

export default useCommercialCatalog;
